function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function mtInitContadores() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;
  var animated = new WeakSet();
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || animated.has(entry.target)) return;
        animated.add(entry.target);
        var el = entry.target;
        var end = parseFloat(el.dataset.mtValor || '0');
        var suffix = el.dataset.mtSufijo || '';
        var dur = 1200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var val = Math.round(end * eased);
          el.textContent = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitContadores();
});
